import styled from "@emotion/styled";
import { Button } from "react-aria-components";
import { Theme } from "@emotion/react";

// Shared base styles
const sharedSectionStyles = ({ theme }: { theme: Theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing["0.5"]};

  width: 100%;
  padding: ${theme.spacing["2"]};
  background-color: ${theme.colors.background.button.onChrome.default};
  border-radius: ${theme.borderRadius.xlarge};
  border: none;
  cursor: pointer;
  font-family: inherit;

  &:hover:not(:disabled) {
    background-color: ${theme.colors.background.button.onChrome.hover};
    transition: 0.2s all;
  }

  &:hover:not(:disabled) [data-right-buttons] {
    opacity: 1;
    width: auto;
  }

  &:disabled {  
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledSectionItemContainer = styled.div<{
  $hasUnreadUpdate?: boolean;
  $indent?: boolean;
}>`
  ${sharedSectionStyles}
  background-color: ${({ $hasUnreadUpdate, theme }) =>
    $hasUnreadUpdate
      ? theme.colors.background.banner.emphasis
      : theme.colors.background.button.onChrome.default};
  margin-left: ${({ $indent, theme }) => ($indent ? theme.spacing["2"] : 0)};
  width: ${({ $indent, theme }) => ($indent ? `calc(100% - ${theme.spacing["2"]})` : "100%")};

  &:hover:not(:disabled) {
    background-color: ${({ $hasUnreadUpdate, theme }) =>
      $hasUnreadUpdate
        ? theme.colors.background.banner.emphasis
        : theme.colors.background.button.onChrome.hover};
  }
`;

export const StyledSectionHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  width: 100%;

  &:hover [data-right-buttons] {
    opacity: 1;
    width: auto;
  }

  // Always show the right buttons on mobile
  @media (${({ theme }) => theme.breakpoints.phone}) {
    [data-right-buttons] {
      opacity: 1;
      width: auto;
    }
  }
`;

export const StyledSectionHeaderClickable = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  flex: 1;
  min-width: 0;
  padding: ${({ theme }) => theme.spacing["2"]};
  background-color: ${({ theme }) => theme.colors.background.button.onChrome.default};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  border: none;
  cursor: pointer;
  font-family: inherit;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.background.button.onChrome.hover};
    transition: 0.2s all;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledSectionItemContainerLeft = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
`;

export const StyledSectionItemContainerRight = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  flex-shrink: 0;
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition:
    opacity 0.2s ease,
    width 0.2s ease;
`;
